export enum TwoFactorMethod {
  SMS = "sms",
  AuthenticatorApp = "totp",
  AuthenticatorAppPending = "totp_pending"
}
